import { conIva } from "../../../shared";
import { fechaLocal } from "./periodos";

// Cálculos del panel sobre los renglones de admin/indicadores/facturacion (un
// renglón por ítem de factura o de planificación). Todo se suma por ítem, así
// que los filtros por cliente o por tipo de certificado se aplican sin perder
// precisión cuando una factura mezcla procesos.

// Valor del filtro de tipo de certificado para los ítems sin tipo (los que se
// cargaron a mano en la factura, sin proceso).
export const SIN_TIPO = "sin";

/**
 * Los ítems de una moneda. Si es la principal entran todas las facturas: las
 * de otras monedas con el monto multiplicado por su tipo de cambio, y marcadas
 * con la moneda principal para que el resto de los cálculos las trate igual.
 * Las facturas viejas sin tipo de cambio se toman 1 a 1, que es lo mismo que
 * hizo la migración que lo agregó.
 */
export function itemsEnMoneda(items, monedaId, monedaPrincipalId) {
  if (monedaId == null) return [];
  if (monedaId !== monedaPrincipalId) {
    return items.filter((i) => i.monedaId === monedaId);
  }
  return items.map((i) =>
    i.monedaId === monedaId
      ? i
      : { ...i, monto: i.monto * (i.tipoCambio ?? 1), monedaId }
  );
}

export function filtrarItems(items, { monedaId, clienteId, certificadoTipoId }) {
  return items.filter(
    (i) =>
      i.monedaId === monedaId &&
      (clienteId == null || i.clienteId === clienteId) &&
      (certificadoTipoId == null ||
        (certificadoTipoId === SIN_TIPO
          ? i.certificadoTipoId == null
          : i.certificadoTipoId === certificadoTipoId))
  );
}

export function montoDe(item, { mostrarConIva, iva }) {
  return mostrarConIva && item.masIva ? conIva(item.monto, iva) : item.monto;
}

const enRango = (fecha, rango) =>
  fecha != null && fecha >= rango.desde && fecha <= rango.hasta;

function totalizar(items, opciones, clave) {
  return {
    monto: items.reduce((suma, i) => suma + montoDe(i, opciones), 0),
    cantidad: new Set(items.map((i) => i[clave])).size
  };
}

/**
 * Totales de las tarjetas del panel, solo del período elegido.
 *
 * - Facturado: lo emitido en el período, sin las anuladas.
 * - Cobrado: lo ya pagado de lo emitido en el período, sin importar cuándo se
 *   pagó, sin las anuladas.
 */
export function resumen(facturas, rango, opciones) {
  const vigentes = facturas.filter((i) => !i.anulada);

  return {
    facturado: totalizar(
      vigentes.filter((i) => enRango(fechaLocal(i.fecha), rango)),
      opciones,
      "facturaId"
    ),
    anuladas: new Set(
      facturas
        .filter((i) => i.anulada && enRango(fechaLocal(i.fecha), rango))
        .map((i) => i.facturaId)
    ).size,
    cobrado: totalizar(
      vigentes.filter((i) => i.fechaPago && enRango(fechaLocal(i.fecha), rango)),
      opciones,
      "facturaId"
    )
  };
}

// Los ítems emitidos en el período. La API manda además todo lo impago, para
// la medida de pendiente de la gráfica; eso queda afuera del detalle si no se
// emitió en el período.
export function itemsDelPeriodo(facturas, rango) {
  return facturas.filter((i) => enRango(fechaLocal(i.fecha), rango));
}
